import { useState, createContext, useEffect, useContext } from "react";
import api from "../services/api";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";

export const AuthContext = createContext({});

export default function AuthProvider({ children }) {
  const [user, setUser] = useState({ status: false });
  const [loadingAuth, setLoadingAuth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [permissao, setPermissao] = useState([]);

  function buscaUser() {
    const storageUser = localStorage.getItem("userSistema");

    if (storageUser) {
      try {
        let dataUser = JSON.parse(storageUser);
        if (dataUser.token) {
          let decode = jwt_decode(dataUser.token);
          setPermissao([decode.permissao]);
          setUser(dataUser);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        localStorage.removeItem("userSistema");
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    buscaUser();
  }, []);

  //INSERE NO STORAGE AS INFORMAÇÕES DO USUARIO
  function storageUser(data) {
    localStorage.setItem("userSistema", JSON.stringify(data));
  }

  //FAZ LOGIN
  async function signIn(user, pass) {
    setLoadingAuth(true);
    await api
      .post(
        "/login",
        {
          usuario: user,
          senha: pass,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      .then(async (resp) => {
        if (resp.data.dois_fatores) {
          await sendVerificationEmail(resp.data.email, resp.data.token);
          setLoadingAuth(false);
        } else {
          let decoder = jwt_decode(resp.data.token);
          setUser(resp.data);
          storageUser(resp.data);
          setPermissao([decoder.permissao]);
          setLoadingAuth(false);
        }
      })
      .catch((error) => {
        toast.error(error.response.data.error);
        setLoadingAuth(false);
      });
  }

  //FAZ LOGOUT
  function signOut() {
    localStorage.clear();
    window.location.reload();
  }

  async function buscaUsuarios() {
    setLoadingAuth(true);
    await api
      .get("/usuarios", {
        headers: {
          Authorization: user.token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then(
        ((resp) => {
          setLoadingAuth(false);
          return resp.data;
        }).catch((error) => {
          toast.error(error.response.data.error);
          setLoadingAuth(false);
        })
      );
  }

  async function sendVerificationEmail(email, token) {
    try {
      const response = await api.post(
        "/usuarios/send-verification",
        { email: email },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message);
    } catch (error) {
      console.error("Erro ao enviar e-mail de verificação:", error);
      toast.error(error.response?.data?.error || "Erro ao enviar e-mail.");
    }
  }

  return (
    <AuthContext.Provider
      value={{
        signed: user.status,
        user,
        loading,
        signOut,
        signIn,
        loadingAuth,
        buscaUsuarios,
        permissao,
        buscaUser,
        sendVerificationEmail,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
